import React, { useEffect, useState } from "react";
import AssetModal from "./AssetModal";

// A sticker for the machine. Scanning it opens the machine's page with the
// breakdown form already up — sign-in still applies.
export default function QrLabelModal({ machine, onClose }) {
  const [src, setSrc] = useState(null);
  const url = `${window.location.origin}/manufacturing/assets/machines/${machine.id}?report=1`;

  useEffect(() => {
    // Loaded on demand: only this dialog needs it.
    import("qrcode")
      .then(({ default: QRCode }) => QRCode.toDataURL(url, { width: 480, margin: 1, errorCorrectionLevel: "M" }))
      .then(setSrc)
      .catch(() => setSrc(null));
  }, [url]);

  const print = () => {
    // Print only the label: the page hides everything else while this class is on.
    document.body.classList.add("am-printing");
    const done = () => {
      document.body.classList.remove("am-printing");
      window.removeEventListener("afterprint", done);
    };
    window.addEventListener("afterprint", done);
    window.print();
  };

  return (
    <AssetModal
      title="Machine QR label"
      onClose={onClose}
      footer={
        <>
          {src && (
            <a className="am-btn am-btn-ghost" href={src} download={`${machine.code}-qr.png`}>Download PNG</a>
          )}
          <button type="button" className="am-btn am-btn-primary" onClick={print} disabled={!src}>Print label</button>
        </>
      }
    >
      <div className="am-qr-label">
        {src ? <img src={src} alt={`QR code for ${machine.code}`} /> : <div style={{ width: 168, height: 168 }} />}
        <div className="am-qr-text">
          <h4>{machine.name}</h4>
          <p><span className="am-code">{machine.code}</span></p>
          {machine.serialNumber && <p>S/N {machine.serialNumber}</p>}
          {machine.location && <p>{machine.location}</p>}
          <p className="am-qr-cta">Broken down? Scan to report.</p>
        </div>
      </div>
      <p className="am-muted" style={{ margin: 0 }}>
        Stick it where operators can reach it. On chat they can also send <strong>/breakdown</strong> and say <strong>{machine.code}</strong>.
      </p>
    </AssetModal>
  );
}
